module.exports = __webpack_public_path__ + "img/TECNOLOGIA-XL7-3.6ce27bcf.jpg";